module.exports = __webpack_public_path__ + "media/personas/bg-days-7fa129d5.jpg";